export function handleFormatTxtToQty(value: string): string {
  let onlyNumbers = value.replace(/\D/g, "");
  onlyNumbers = onlyNumbers.slice(0, 5);
  if (onlyNumbers.length > 2) {
    onlyNumbers = onlyNumbers.slice(0, 2) + "," + onlyNumbers.slice(2);
  }

  return onlyNumbers;
}
